import Header from './Header';
import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';

export default DesktopHeader;
// export default Header;

export { MobileHeader };
